<template>
  <div class="radio-group"
  @click.stop>
    <div v-for="(item, key) in items"
         :key="key"
         :class="['radio-group-item',{'checked': dataValue === item.value}]"
         @mouseenter="$emit('showPopover', getFlightsPopoverData[key].fullString, $event)"
         @mouseleave="$emit('hidePopover')"
    >
      <input type="radio"
             @change="change(item.value)"
             :id="`radio-group-${uniqueId()}`" class="none"
             :value="item.value"
             v-model="dataValue">
      <label 
          :for="`radio-group-${uniqueId()-1}`" 
          v-if="dataValue === item.value" 
          :style="[{'background-color': `${background}`}]"
          >
          {{item.text}}
      </label>
      <label 
          :for="`radio-group-${uniqueId()-1}`" 
          v-else>
          {{item.text}}
      </label>
    </div>
  </div>
</template>

<script>
import {uniqueId} from '../../plugins/methods'

export default {
  name: "RadioGroup",
  props: {
    value: {
      type: Number,
      required: true
    },
    background: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    flightData: {
      type: Object,
      required: true
    },
    fullFlightData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dataValue: null,
      uniqueId: uniqueId
    }
  }, 

  computed: {
    direction() {
      return this.flightData.direction;
    },

    getFlightsRadioData(){
      return this.fullFlightData.flights.filter((item) => item.direction === this.direction)
    },

    getFlightsPopoverData(){
      const radios = this.getFlightsRadioData; 

      return Array.from({ length: this.items.length }).map((item, idx) => {

        if(!item) item = {}

          item.departureCity = radios[idx].departureCity;
          item.arrivalCity = radios[idx].arrivalCity;
          item.code = radios[idx].segments.airline.mtItem.code;
          item.flightNumber = radios[idx].segments.flightNumber;
          item.departureTime = this.items[idx].text;
          item.fligthTime = radios[idx].progress.fligthTime
          item.fullString = `${item.departureCity} – ${item.arrivalCity}, ${item.code} ${item.flightNumber}
          <br>
          ${this.localizeList.departureTime}: ${item.departureTime}
          <br>
          ${this.localizeList.travelTimeTitle}: ${item.fligthTime}`;

          return item
      })
    },
  },

  methods: {
    change(value) {
      this.$emit('input', value)
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dataValue = val
      }
    },
  }
}
</script>

<style scoped>
  .radio-group input.none {
    display: none;
  }

  .radio-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    overflow-y: auto;
  }

  .radio-group-item{
    padding: 5px 0;
  }

  .radio-group-item label {
    /*color: white;*/
    color: black;
    width: max-content;
    padding: 4px 12px;
    border-radius: 15px;
    font-size: 13px;
    /* margin-right: 10px; */
    cursor: pointer;
    background-color: #d1d1d1;
  }

  .radio-group-item.checked label {
    color: white;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
    cursor: default;
  }
</style>